import axiosService from '../services/axiosService';

const LIST_URL = {
    CREATE: '/api/Order/Create',
};

const orderApis = {
    create: (dataPost) => {
        return axiosService.post(LIST_URL.CREATE, dataPost);
    },
};

export default orderApis;
